/*! @pentacode/ui v0.1.0 */
// ../../node_modules/.pnpm/@awesome.me+webawesome@3.14.0_@floating-ui+utils@0.2.11_@types+node@24.19.2_@types+react@19.2.17/node_modules/@awesome.me/webawesome/dist/chunks/chunk.4ZAKP7NY.js
var e = class extends Event {
	constructor() {
		super("wa-show", {
			bubbles: !0,
			cancelable: !0,
			composed: !0
		});
	}
}, t = class extends Event {
	constructor(e) {
		super("wa-hide", {
			bubbles: !0,
			cancelable: !0,
			composed: !0
		}), this.detail = e;
	}
}, n = class extends Event {
	constructor() {
		super("wa-after-hide", {
			bubbles: !0,
			cancelable: !1,
			composed: !0
		});
	}
}, r = class extends Event {
	constructor() {
		super("wa-after-show", {
			bubbles: !0,
			cancelable: !1,
			composed: !0
		});
	}
}, i = [];
function a(e) {
	o(e), i.push(e);
}
function o(e) {
	for (let t = i.length - 1; t >= 0; t--) if (i[t] === e) {
		i.splice(t, 1);
		break;
	}
}
function s(e) {
	return i.length > 0 && i[i.length - 1] === e;
}
// ../../node_modules/.pnpm/nanoid@5.1.11/node_modules/nanoid/url-alphabet/index.js
var c = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", l = (e = 21) => {
	let t = "", n = crypto.getRandomValues(new Uint8Array(e |= 0));
	for (; e--;) t += c[n[e] & 63];
	return t;
};
// ../../node_modules/.pnpm/@awesome.me+webawesome@3.14.0_@floating-ui+utils@0.2.11_@types+node@24.19.2_@types+react@19.2.17/node_modules/@awesome.me/webawesome/dist/chunks/chunk.KNJT7KBU.js
function u(e = "") {
	return `${e}${l()}`;
}
// ../../node_modules/.pnpm/@awesome.me+webawesome@3.14.0_@floating-ui+utils@0.2.11_@types+node@24.19.2_@types+react@19.2.17/node_modules/@awesome.me/webawesome/dist/chunks/chunk.L6CIKOFQ.js
function d(e, t) {
	return new Promise((n) => {
		let r = new AbortController(), { signal: i } = r;
		if (e.classList.contains(t)) return;
		e.classList.add(t);
		let a = !1, o = () => {
			a || (a = !0, e.classList.remove(t), n(), r.abort());
		};
		e.addEventListener("animationend", o, {
			once: !0,
			signal: i
		}), e.addEventListener("animationcancel", o, {
			once: !0,
			signal: i
		}), requestAnimationFrame(() => {
			!a && e.getAnimations().length === 0 && o();
		});
	});
}
// ../../node_modules/.pnpm/@awesome.me+webawesome@3.14.0_@floating-ui+utils@0.2.11_@types+node@24.19.2_@types+react@19.2.17/node_modules/@awesome.me/webawesome/dist/chunks/chunk.PZAN6FPN.js
function f(e, t) {
	let n = {
		waitUntilFirstUpdate: !1,
		...t
	};
	return (t, r) => {
		let { update: i } = t, a = Array.isArray(e) ? e : [e];
		t.update = function(e) {
			a.forEach((t) => {
				let i = t;
				if (e.has(i)) {
					let t = e.get(i), a = this[i];
					t !== a && (!n.waitUntilFirstUpdate || this.hasUpdated) && this[r](t, a);
				}
			}), i.call(this, e);
		};
	};
}
export { a, n as c, s as i, t as l, d as n, o, u as r, r as s, f as t, e as u };

//# sourceMappingURL=chunk.PZAN6FPN-DM97Xg5v.js.map